
































































import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadImage } from "@/request/zhuanbingshujuku";
@Component({})
export default class DetailContentWenjian extends Vue {
  @Prop()
  private content: any;
  private dialogImageUrl = "";
  private dialogVisible = false;
  private fileList: any[] = [];
  private limitedNumber: any = 0;
  private limitedType: any = "";
  private acceptedType: any = "";
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 判断是否为图片需要展示
   */
  private ifPicture(file) {
    const arr: any = ["png", "jpeg", "jpg"];
    let exsit = false;
    arr.map((type: any) => {
      if (file.url.indexOf(type) !== -1) {
        exsit = true;
      }
    });
    return exsit;
  }
  /**
   * @description 超出数量时提示
   */
  private exceedHelp() {
    this.$message.warning("该项最多只能上传" + this.limitedNumber + "个文件");
  }
  /**
   * @description 图片上传预处理
   */
  private beforeUpload(file) {
    const arr = file.name.split(".");
    const fileType = arr[arr.length - 1];
    if (this.acceptedType.includes(fileType)) {
      return true;
    } else {
      this.$message.warning("只能上传特定类型的文件");
      return false;
    }
  }
  /**
   * @description 上传
   */
  private upload(d) {
    const uploadFilePath: any = "ds/file/" + d.file.name;
    const params: any = {
      type: "file",
      base64_image: "",
    };
    const reader = new FileReader();
    reader.readAsDataURL(d.file);
    reader.onload = (e: any) => {
      params["base64_image"] = e.target["result"];
      console.log(params);
      UploadImage(this, params).then((data: any) => {
        console.log(data);
        this.fileList.forEach((file: any) => {
          if (file.uid === d.file.uid) {
            file.url = data.image_url;
          }
          delete file.size;
          delete file.status;
          delete file.percentage;
          delete file.raw;
        });
        this.content.value = this.fileList;
      });
    };
    // this.ossClient
    //   .multipartUpload(d.file.name, d.file)
    //   .then((data: any) => {
    //     this.fileList.forEach((file: any) => {
    //       if (file.uid === d.file.uid) {
    //         console.log(file);
    //         file.url = data.res.requestUrls[0].split("?")[0];
    //       }
    //       delete file.size;
    //       delete file.status;
    //       delete file.percentage;
    //       delete file.raw;
    //     });
    //     this.content.value = this.fileList;
    //   })
    //   .catch((err: any) => {
    //     console.log(err);
    //   });
  }
  /**
   * @description 文件变化时
   */
  private handleFileChange(file, fileList) {
    this.fileList = fileList;
  }
  /**
   * @description 删除文件
   */
  private handleRemove(file) {
    let targetIndex: any = "";
    this.fileList.forEach((f: any, index: any) => {
      if (f.uid === file.uid) {
        targetIndex = index;
      }
    });
    this.fileList.splice(targetIndex, 1);
  }
  /**
   * @description 图片预览
   */
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  /**
   * @description 下载
   */
  private handleDownload(file) {
    window.open(file.url);
    // const result = this.ossClient.signatureUrl(file.name);
    // window.open(result);
  }
  /**
   * @description
   */
  private mounted() {
    // 初始化已有文件
    this.fileList = this.content.value;
    this.content.setting.forEach((setting: any) => {
      // 限制上传数量
      if (setting.name === "最多上传") {
        this.limitedNumber = setting.value;
      }
      // 限制上传格式
      if (setting.name === "支持格式") {
        this.limitedType = setting.value.join(",");
        const arr: any = [];
        setting.value.map((value: any) => {
          arr.push("." + value);
        });
        this.acceptedType = arr.join(",");
      }
    });
  }
}
